module.exports = __webpack_public_path__ + "fonts/bitfont.4f3aae1c.ttf";